import { render } from "./ListarFormasPagamentos.vue?vue&type=template&id=56702cef"
import script from "./ListarFormasPagamentos.vue?vue&type=script&lang=js"
export * from "./ListarFormasPagamentos.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__